<template>
  <div class="teacher-evaluation-result">
    <!-- 操作栏容器 -->
    <div class="teacherEvaluation-info-operation-container">
      <div class="teacherEvaluation-info-search-container">
        <!-- 搜索框 -->
        <search class="search" placeholder="请输入教师名称" @search="teacherNameSearch" />
        <search
          class="search"
          placeholder="请输入教师工号"
          @search="teacherNumberSearch"
        />
        <!-- <el-date-picker style="width: 100px; margin-left: 20px" v-model="searchInfo.schoolYear" type="year"
          placeholder="学年" @change="schoolYearChangeHandle">
        </el-date-picker> -->
        <el-select
          style="width: 100px; margin-left: 20px"
          v-model="searchInfo.semester"
          placeholder="学期"
          clearable
          @change="semesterChangeHandle"
        >
          <el-option
            v-for="item in semesterOptions"
            :key="item.dictValue"
            :label="item.dictLabel"
            :value="item.dictValue"
          >
          </el-option>
        </el-select>
        <el-select
          style="width: 150px; margin-left: 20px"
          v-model="searchInfo.evaluativeFeature"
          placeholder="评价要素"
          clearable
          @change="evaluativeFeatureChangeHandle"
        >
          <el-option
            v-for="item in evaluativeFeatureOptions"
            :key="item.dictValue"
            :label="item.dictLabel"
            :value="item.dictValue"
          >
          </el-option>
        </el-select>
        <year-range-picker
          style="width: 300px; margin-left: 20px"
          v-model="searchInfo.schoolYear"
          @change="schoolYearChangeHandle"
        />
      </div>
      <div class="teacherEvaluation-info-button-container">
        <el-button type="success" round size="small" @click="deriveStatisticalResult"
          >导出结果</el-button
        >
      </div>
    </div>
    <!-- 列表栏容器 -->
    <div class="teacherEvaluation-info-table-container" v-bitmap="getListResult">
      <teacherEvaluationList
        class="teacherEvaluation-list"
        v-show="total"
        :teacherEvaluationList="teacherEvaluationList"
      />
    </div>
    <!-- 分页容器 -->
    <div class="teacherEvaluation-info-pagination-catainer">
      <pagination
        :total="parseInt(total)"
        :pageSize="parseInt(pageSize)"
        @currentPageNumChange="currentPageNumChange"
        @handleSizeChange="handleSizeChange"
      />
    </div>
  </div>
</template>

<script>
// 搜索框
import search from "@/components/search/search.vue";
import teacherEvaluationList from "./components/teacher-evaluation-list/teacherEvaluationList.vue";
import { baseURL } from "@/api/request"; // 服务器地址
export default {
  components: {
    search,
    teacherEvaluationList,
  },
  data() {
    return {
      semesterOptions: [],
      // 搜索条件
      searchInfo: {
        teacherName: "",
        teacherNumber: "",
        schoolYear: "", // 学年
        semester: "", // 学期
        evaluativeFeature: "", // 评价要素
      },
      total: 1, // 总条数
      pageNum: 1, // 当前页码
      pageSize: 10, // 每页条数
      teacherEvaluationList: [],
      getListResult: "success",
      schoolInfo: {}, // 学校信息
      evaluativeFeatureOptions: [],
    };
  },
  created() {
    Promise.all([
      this.getSchoolDetails(), // 查询学校信息(导出时需要用到学年学期参数)
      this.getSemesterOptions(), // 获取学期类型选择列表数据
      this.getEvaluativeFeature(),
    ]).then(() => {
      // this.getTeacherEvaluationList(); // 获取教师统计结果列表
    });
  },
  methods: {
    // 获取评价要素
    getEvaluativeFeature() {
      this.get(`${this.$url.getDictType}/sc_evaluative_feature`).then((res) => {
        this.evaluativeFeatureOptions = res.data;
        // 默认选中第一个值
        if (res.data && res.data.length > 0) {
          this.searchInfo.evaluativeFeature = res.data[0].dictValue;
        }
      });
    },
    // 查询学校信息
    getSchoolDetails() {
      this.get(this.$url.getSchoolDetails).then((res) => {
        this.schoolInfo = res.data;
        // 默认选中学年学期
        this.searchInfo.schoolYear = res.data.schoolYear;
        this.searchInfo.semester = res.data.semester;
        this.getTeacherEvaluationList(); // 获取教师统计结果列表
      });
    },
    // 导出统计结果
    deriveStatisticalResult() {
      let { semester, schoolYear, id } = this.schoolInfo;
      let { evaluativeFeature } = this.searchInfo;
      let action = `${baseURL}${this.$url.teacherEvaluationExcelPC}?semester=${semester}&schoolYear=${schoolYear}&schoolId=${id}&evaluativeFeature=${evaluativeFeature}`;
      window.open(action);
    },
    // 获取教师统计结果列表
    getTeacherEvaluationList() {
      let {
        teacherName,
        teacherNumber,
        schoolYear,
        semester,
        evaluativeFeature,
      } = this.searchInfo;
      let data = {
        schoolId: this.user.schoolId,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        schoolYear,
        semester,
        evaluativeFeature,
      };

      // 检查值是否为空（或者您认为的“无效”值），如果非空，则添加到 data 中
      if (teacherName) {
        data.teacherName = teacherName;
      }
      if (teacherNumber) {
        data.teacherNumber = teacherNumber;
      }
      // if (schoolYear) {
      //   data.schoolYear = schoolYear;
      // }
      // if (semester) {
      //   data.semester = semester;
      // }
      // if (evaluativeFeature) {
      //   data.evaluativeFeature = evaluativeFeature;
      // }
      this.get(this.$url.selectAllTeacherRecords, data).then((res) => {
        // console.log("教师统计结果列表==>", res);
        if (res.code !== 200) {
          this.$message.error(res.msg || "获取统计信息错误");
          this.getListResult = "error";
          return;
        }
        this.teacherEvaluationList = res.rows;
        this.total = res.total;
        this.getListResult = res.total > 0 ? "success" : "nullData";
      });
    },
    // 获取学期类型选择列表数据
    getSemesterOptions() {
      this.get(`${this.$url.getDictType}/semester_type`).then((res) => {
        // console.log("学期类型==>", res);
        this.semesterOptions = res.data;
      });
    },
    // 教师名称搜索
    teacherNumberSearch(e) {
      this.searchInfo.teacherNumber = e;
      this.getTeacherEvaluationList();
    },
    // 教师工号搜索
    teacherNameSearch(e) {
      this.searchInfo.teacherName = e;
      this.getTeacherEvaluationList();
    },
    // 学期搜索
    semesterChangeHandle(e) {
      this.searchInfo.semester = e;
      this.getTeacherEvaluationList();
    },
    // 学年搜索
    schoolYearChangeHandle(e) {
      // this.searchInfo.schoolYear = e ? "" + e.getFullYear() : "";
      this.getTeacherEvaluationList();
    },
    // 评价要素搜索
    evaluativeFeatureChangeHandle(e) {
      this.searchInfo.evaluativeFeature = e;
      this.getTeacherEvaluationList();
    },
    // 分页组件传递过来的页码修改事件
    currentPageNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getTeacherEvaluationList();
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.getTeacherEvaluationList();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./teacherEvaluationResult.scss";
</style>
